module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/antoinette-efc381aa5b25a5636e15cb020b2f731e.jpg";